export default __webpack_public_path__ + "static/media/generations.c51ab322.jpg";